import React from 'react';
import ChakraUIRenderer from 'chakra-ui-markdown-renderer';
import ReactMarkdown from 'react-markdown';

const RenderChakraMarkdown = props => {
  return <ReactMarkdown components={ChakraUIRenderer()} {...props} />;
};

export default RenderChakraMarkdown;
